import React from "react";
import {LineChart,AreaChart,Area, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Line, ResponsiveContainer} from "recharts";


const data = [{
    name: 'Page A',
    uv: 10,
    pv: 2400,
    amt: 2400,
}, {
    name: 'Page B',
    uv: 3000,
    pv: 1398,
    amt: 2210,}, {
    name: 'Page C',
    uv: 2000,
    pv: 9800,
    amt: 2290 },
    {
        name: 'Page D',
        uv: 2780,
        pv: 3908,
        amt: 2000,
    },
    {
        name: 'Page E',
        uv: 1890,
        pv: 4800,
        amt: 2181,
    },
    {
        name: 'Page F',
        uv: 2390,
        pv: 3800,
        amt: 2500,
    },
    {
        name: 'Page G',
        uv: 3490,
        pv: 4300,
        amt: 2100,
    },{
        name: 'Page A',
        uv: 4000,
        pv: 2400,
        amt: 2400,
    }, {
        name: 'Page B',
        uv: 3000,
        pv: 1398,
        amt: 2210,}, {
        name: 'Page C',
        uv: 2000,
        pv: 9800,
        amt: 2290 },
    {
        name: 'Page D',
        uv: 2780,
        pv: 3908,
        amt: 2000,
    },
    {
        name: 'Page E',
        uv: 1890,
        pv: 4800,
        amt: 2181,
    },
    {
        name: 'Page F',
        uv: 2390,
        pv: 3800,
        amt: 2500,
    },
    {
        name: 'Page G',
        uv: 3490,
        pv: 4300,
        amt: 2100,
    } ];

function Graph(props){

    var moment = require('moment');
    //var viewsRef = firebase.database().ref("Business/Events/Product_Views");

    var colors = ["#d70206",
        "#0d47a1",
        "#388e3c",
        "#d17905",
        "#C2185B"]

    const [weekdays, setWeekDays] = React.useState([]);
    const [labelArray, setLabelArray] = React.useState([]);
    const [dataArray, setDataArray] = React.useState([]);
    const [majorArray, setMajorArray] = React.useState([1,2,3]);
    const [loading , setLoading] = React.useState(false);


    var todayNum = moment().isoWeekday();
    //var lastWeekToday = todayNum - 14;
    //console.log(moment().weekday(lastWeekToday));

    React.useEffect(() => {

        //setLoading(true);
        var periodNumber;
        if(props.period === "Last 7 days" ){
            periodNumber = 7;
        }else if(props.period === "Last 30 days"){
            periodNumber = 30;
        } else {
            periodNumber = 90;
        }

        var weekArray = [];
        var labelArray = [];

        for(var i=0; i<periodNumber; i++){
            weekArray.push({"date" : moment().weekday(todayNum - i).format("YYYY-MM-DD"),
                "name" : moment().weekday(todayNum - i).format("dddd")});
            labelArray.push(moment().weekday(todayNum - i).format("DD/MM"));
        }

        setLabelArray(labelArray);
        setWeekDays(weekArray);

    }, [])


    return (

        <ResponsiveContainer width="100%" height={250} className="d-flex justify-content-center text-center">
            <LineChart
                data={data}
                margin={{
                    top: 5,
                    right: 10,
                    left: 0,
                    bottom: 5,
                }}>
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Line type="monotone" strokeWidth={1} dataKey="uv" stroke="#8884d8" fillOpacity={0.6} fill="url(#colorUv)" />
                <Line type="monotone" strokeWidth={1} dataKey="amt" stroke="#82ca9d" fillOpacity={0.6} fill="url(#colorUv)" />
            </LineChart>
        </ResponsiveContainer>


    )
}

export default Graph;